import React, { forwardRef, ReactNode, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';

import './styles.scss';

interface Props {
    type?: 'primary' | 'secondary' | 'link';
    children: ReactNode;
    className?: string;
    disabled?: boolean;
    routerLinkPath?: string;
    onClick?: () => void;
}

// eslint-disable-next-line react/display-name
export const Button = forwardRef<HTMLButtonElement, Props>(
    ({ type = 'primary', children, className = '', disabled, routerLinkPath, onClick }, ref) => {
        const location = useLocation();

        const classNameByType = useMemo(() => {
            switch (type) {
                case 'link':
                    return 'app-button--link';
                case 'secondary':
                    return 'app-button--secondary';
                case 'primary':
                default:
                    return '';
            }
        }, [type]);

        if (routerLinkPath) {
            return (
                <Link
                    to={routerLinkPath}
                    className={`app-button ${classNameByType} ${className}`}
                    state={{ from: location }}
                >
                    {children}
                </Link>
            );
        }

        return (
            <button
                className={`app-button ${classNameByType} ${className}`}
                disabled={disabled}
                onClick={onClick}
                ref={ref}
            >
                {children}
            </button>
        );
    },
);
